import React from "react";
import { Sparkles } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

function NotesSection({ notes, paymentTerms, onChange, onImprove }) {
  return (
    <section className="form-section">
      <h2 className="form-section-title">Notas</h2>
      <div className="space-y-4">
        <div>
          <div className="flex justify-between">
            <Label>Notas</Label>
            <Button type="button" variant="ghost" size="sm" className="h-8 w-8 p-0 hover:bg-purple-100"
              onClick={function() { if(notes) onImprove(notes, "notes"); }}
              disabled={!notes} data-testid="ai-notes">
              <Sparkles size={16} className="text-purple-500" />
            </Button>
          </div>
          <Textarea value={notes} placeholder="Notas adicionales..."
            onChange={function(e) { onChange({ notes: e.target.value }); }}
            className="input-elite mt-1 min-h-[60px]" data-testid="notes" />
        </div>
        <div>
          <div className="flex justify-between">
            <Label>Condiciones de Pago</Label>
            <Button type="button" variant="ghost" size="sm" className="h-8 w-8 p-0 hover:bg-purple-100"
              onClick={function() { if(paymentTerms) onImprove(paymentTerms, "paymentTerms"); }}
              disabled={!paymentTerms} data-testid="ai-payment">
              <Sparkles size={16} className="text-purple-500" />
            </Button>
          </div>
          <Textarea value={paymentTerms} placeholder="Pago a 30 días..."
            onChange={function(e) { onChange({ paymentTerms: e.target.value }); }}
            className="input-elite mt-1 min-h-[60px]" data-testid="payment-terms" />
        </div>
      </div>
    </section>
  );
}

export default NotesSection;
